import { useItemMasterQuery as useItemMasterQueryGenerated } from '../../../../../graphql'

export default function useItemMasterQuery( id: string ) {
	const { data, loading, error } = useItemMasterQueryGenerated( {
		variables: { id },
		skip: !id,
	} )

	return {
		itemMaster: data?.itemMaster ?? null,
		loading,
		error,
	}
}
